import React from 'react';
import { ControlledList, DataGridLayout, RelationListLayout } from 'framework/list';
import { FullDateField, TextField } from 'framework/ui/field';
import ProcessInstanceLinkField from 'domain/gpo/cockpit/instance/shared/ProcessInstanceLinkField';
import IncidentCountField from 'domain/gpo/cockpit/instance/shared/IncidentCountField';
import ProcessDefinitionField from 'domain/gpo/cockpit/instance/shared/ProcessDefinitionField';
import ProcessStateField from 'domain/gpo/cockpit/instance/shared/ProcessStateField';
import { EnrichedTraceRow } from 'domain/gpo/cockpit/instance/Show/tracing/processEventFlowService';

interface Props {
  header: string;
  traces: EnrichedTraceRow[];
  headerVariant?: 'h1' | 'h2' | 'h3' | 'h4';
}

const TraceSection = ({ header, traces, headerVariant = 'h3' }: Props) => {
  if (traces.length === 0) {
    return null;
  }

  return (
    <ControlledList data={{ items: traces, totalPages: 1, totalElements: traces.length }}>
      <RelationListLayout header={header} headerVariant={headerVariant} actions={[]}>
        <DataGridLayout showTotal={false} showPagination={false} buttons={[]} isSmallTable rowKeySource="id">
          <ProcessInstanceLinkField source="processInstanceId" />
          <IncidentCountField source="incidentCount" label="Incidents" />
          <ProcessDefinitionField label="Process key / Version" keySource="processKey" versionSource="processVersion" />
          <TextField source="businessKey" label="Business key" />
          <ProcessStateField source="state" />
          <FullDateField source="startDateTime" label="Start date" />
          <FullDateField source="endDateTime" label="End date" />
          <TextField source="correlationKey" label="Correlation key" />
        </DataGridLayout>
      </RelationListLayout>
    </ControlledList>
  );
};

export default TraceSection;
